var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "url(#paint0_linear_468_1454)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 20.8335C26.6673 25.0002 23.7507 27.0835 20.284 28.2919C20.1025 28.3534 19.9053 28.3505 19.7257 28.2835C16.2507 27.0835 13.334 25.0002 13.334 20.8335V15.0002C13.334 14.7792 13.4218 14.5672 13.5781 14.411C13.7343 14.2547 13.9463 14.1669 14.1673 14.1669C15.834 14.1669 17.9173 13.1669 19.3673 11.9002C19.5439 11.7494 19.7684 11.6665 20.0007 11.6665C20.2329 11.6665 20.4574 11.7494 20.634 11.9002C22.0923 13.1752 24.1673 14.1669 25.834 14.1669C26.055 14.1669 26.267 14.2547 26.4232 14.411C26.5795 14.5672 26.6673 14.7792 26.6673 15.0002V20.8335Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_1454",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B7FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1447E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate1);
export default __webpack_public_path__ + "static/media/Corporate-1.86de85097c6a4753dda37278cb22959f.svg";
export { ForwardRef as ReactComponent };